<template>
	<div class="expert-score">
		<div class="container-fluid">
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row mb-1">
							<div class="col-xl-6">专家评分</div>
							<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
						</div>
						<div class="card">
							<div class="card-body">
								
								<div class="tab_box mb-3" v-if="tabList.length">
									<div class="tab_item" :class="tabsActive == item.id ? 'active' : ''" v-for="item in tabList" :key="item.id" @click="handleTabChange(item.id)">
										{{ item.title }}
									</div>
								</div>
								
								<el-table :header-cell-style="tableHeaderStyle" ref="multipleTable" :data="list" tooltip-effect="light" style="width: 100%" border>
									<el-table-column prop="name" label="评审信息名称" min-width="150">
										<template slot-scope="scope">
											<span class="project_name" @click="toReview(scope.row)">{{ scope.row.name }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="toReviewDeclareNumber" label="待评课题数" min-width="80"></el-table-column>
									<el-table-column prop="hasReviewDeclareNumber" label="已评数量" min-width="80"></el-table-column>
									<el-table-column prop="residueDeclareNumber" label="剩余数量" min-width="80"></el-table-column>
									<el-table-column prop="isSubmit" label="是否提交" min-width="100">
										<template slot-scope="scope">
											<span>{{ scope.row.isSubmit === 0 ? '评审中' : '已提交' }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="reviewStartTime" label="开始时间" min-width="120"></el-table-column>
									<el-table-column prop="reviewEndTime" label="预计结束时间" min-width="120"></el-table-column>
									<el-table-column label="操作" min-width="100">
										<template slot-scope="scope">
											<el-button type="primary" size="small" @click="toReview(scope.row)">进入评审</el-button>
										</template>
									</el-table-column>
								</el-table>
								
								<!-- 分页器 -->
								<div class="text-right mt-2">
									<el-pagination
										layout="total, sizes, prev, pager, next, jumper"
										background
										:current-page="query.pageNumber"
										:page-sizes="[10, 50, 100, 200]"
										:page-size="query.pageSize"
										:total="total"
										@size-change="handleSizeChange"
										@current-change="handlePageChange"
									></el-pagination>
								</div>
							</div>
							<!-- end card-body-->
						</div>
						<!-- end card -->
					</div>
					<!-- end col-->
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import {getReviewAuthByUser, getReviewList} from '@/api/after/topicManage.js'

import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
	name: 'expertScoreList',
	components: { Breadcrumb },
	data() {
		return {
			tableHeaderStyle: { backgroundColor: '#7e9be2', color: '#fff',textAlign:'center' },
			tabList: [],
			projectData: {},
			tabsActive: 0,
			list: [],
			total: 0,
			query: {
				pageNumber:1,//页码,默认为1,示例值(1)			
				pageSize:10,//页大小,默认为10,示例值(10)			
				reviewType:'',//审查状态(0:初审,1复审,2:终审)			
			}
		};
	},
	async mounted() {
		await this.getExpertAuth()
		this.getData()
	},
	methods: {
		// 判断当前专家的评审权限
		async getExpertAuth(){
			const res = await getReviewAuthByUser()
			if (res.code == 200) {
				console.log('当前用户评审权限',res);
				if (res.data.internState) {
					this.tabList.push({
						id:0,
						title:"结题初评"
					})
					if (this.query.reviewType === '') {
						this.query.reviewType = 0
					}
				}
				if (res.data.reviewState) {
					this.tabList.push({
						id:1,
						title:"结题复评"
					})
					if (this.query.reviewType === '') {
						this.query.reviewType = 1
					}
				}
				if (res.data.finalState) {
					this.tabList.push({
						id:2,
						title:"结题终评"
					})
					if (this.query.reviewType === '') {
						this.query.reviewType = 2
					}
				}
			}else{
				this.$message.error(res.data)
			}
		},
		// 获取数据列表
		getData(isNum) {
			if (isNum) this.query.pageNumber = 1;
			getReviewList(this.query).then(res => {
				if (res.code == 200) {
					console.log('评审列表',res);
					this.list = res.data.records;
					this.total = res.data.total;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		
		handleTabChange(num) {
			this.query.reviewType = num;
			this.tabsActive = num;
			this.getData(true);
		},
		toReview(item) {
			this.$router.push({
				path: '/backstage/topicManageTopicList',
				query: { data: JSON.stringify(item) }
			});
		},
		// 分页导航
		handlePageChange(val) {
			this.query.pageNumber = val;
			this.getData();
		},
		handleSizeChange(val) {
			this.query.pageSize = val;
			this.getData(true);
		}
	}
};
</script>

<style scoped>
.tab_box {
	border-bottom: 2px solid #56acf5;
	display: flex;
}
.tab_box .tab_item {
	padding: 0 20px;
	height: 40px;
	box-sizing: border-box;
	line-height: 40px;
	display: inline-block;
	list-style: none;
	font-size: 14px;
	font-weight: 500;
	color: #303133;
	border: 1px solid rgb(223, 223, 223);
	border-bottom: none;
	cursor: pointer;
}
.tab_box .tab_item.active {
	color: #fff;
	background: #56acf5;
	border-left: none;
	border-color: #56acf5;
}
/deep/.el-table th > .cell {
	text-align: center;
}

/deep/.el-table .cell {
	text-align: center;
}
/deep/.el-tabs__item.is-active {
	color: #fff;
	background: #56acf5;
}
/deep/.el-tabs--card > .el-tabs__header {
	border-bottom: 2px solid #56acf5;
}
.project_name {
	color: #56acf5;
	cursor: pointer;
}
</style>
